import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ComparisonSection } from '../components/sections/ComparisonSection';
import { HighlightSection } from '../components/sections/HighlightSection';
import { ExamplesSection } from '../components/sections/ExamplesSection';
import { ProductSection } from '../components/sections/ProductSection';
import { FeaturesSection } from '../components/sections/FeaturesSection';
import { FuturePacingSection } from '../components/sections/FuturePacingSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { PricingSection } from '../components/sections/PricingSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FAQSection } from '../components/sections/FAQSection';
import { PurchaseNotification } from '../components/ui/PurchaseNotification';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-367">
      <HeroSection data-id="element-368" />
      <ComparisonSection data-id="element-369" />
      <HighlightSection data-id="element-370" />
      <ExamplesSection data-id="element-371" />
      <ProductSection data-id="element-372" />
      <FeaturesSection data-id="element-373" />
      <FuturePacingSection data-id="element-374" />
      <TestimonialsSection data-id="element-375" />
      <PricingSection data-id="element-376" />
      <GuaranteeSection data-id="element-377" />
      <FAQSection data-id="element-378" />

      {/* Footer */}
      <footer className="bg-stone-900 text-white py-12" data-id="element-379">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-380">
          <p className="text-lg mb-4 font-serif" data-id="element-381">O Efeito Boutique™</p>
          <p className="text-stone-400 text-sm" data-id="element-382">
            © 2024 Todos os direitos reservados. | Política de Privacidade |
            Termos de Uso
          </p>
        </div>
      </footer>

      {/* Purchase Notifications */}
      <PurchaseNotification data-id="element-383" />
    </div>;
}